import { FormControl, Autocomplete, TextField } from "@mui/material";
import { useCallback, useState } from "react";
import tripService from "services/tripService";
import { debounce } from "lodash";

const TripNumberSearch = ({
  tripNumber = undefined,
  onChange,
  marginTop = 0,
  marginLeft = 0,
  marginRight = 0,
  tripNumberSearchKey = 1,
}) => {
  const [tripNumbers, setTripNumbers] = useState([]);
  const debounceSearch = useCallback(debounce(handleSearch, 500), []);
  
  function handleSearch(value) {
    tripService.searchTripNumber(value).then((r) => {
       setTripNumbers(r);
    });
  }
  return (
    <FormControl sx={{ mt: marginTop ?? 0, ml: marginLeft ?? 0, mr: marginRight ?? 0, p: 0, minWidth: 300 }}>
      <Autocomplete
        id="tripNumber"
        key={tripNumberSearchKey}
        sx={{
          "& .MuiOutlinedInput-root": {
            padding: "4px!important",
          },
        }}
        freeSolo
        autoHighlight={true}
        getOptionLabel={(o) => (o ? (typeof o === 'object' ? `${o.id} (${o.controlNumber})` : o.toString())  : "")}
        options={tripNumbers}
        value={tripNumber ?? null}
        onInputChange={(e, value, reason) => {
          if (reason === "clear") {
            onChange(null);
          } else {
            if (value?.length > 2)
              debounceSearch(value);
            else setTripNumbers([]);
          }
        }}
        renderInput={(params) => <TextField {...params} label="Trip / Control Number" />}
        onChange={(e, value) => onChange(value)}
      />
    </FormControl>
  );
};
export default TripNumberSearch;
